import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

/**
 * Styled container for the main page's vertical animation container.
 */
const VerticalAnimationContainer = styled.div<React.CSSProperties>`
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 1;
`;

export default withAnimation(VerticalAnimationContainer);
